/*  @flow */
import * as React from 'react';

import ActionButton from 'components/ActionsList/components/ActionButton/ActionButton';

import {
  updateEditProject,
  updateAssignProjectLead,
  updateAssignUsers,
  updateRemoveUsers,
  updateAssignCostCenters,
  updateRemoveCostCenters,
  updateExtendProject,
  updateEndProject,
  updateUnarchiveProject,
  updateArchiveProject,
} from 'permissions/project';

export const actionsListProject: Array<*> = [
  {
    label: 'general:actions.edit_project',
    icon: '#icon-edit',
    class: '',
    action: 'edit',
    permissions: updateEditProject,
    type: 'link',
    to: { pathname: '/projects/edit', setStateData: true },
  },
  {
    label: 'general:actions.reassign_project_lead',
    icon: '#icon-users',
    class: '',
    action: 'reassignLead',
    permissions: updateAssignProjectLead,
  },
  {
    label: 'general:actions.assign_engineer_plural',
    icon: '#icon-users',
    class: '',
    action: 'assignEngineer',
    permissions: updateAssignUsers,
  },
  {
    label: 'general:actions.remove_engineer_plural',
    icon: '#icon-revoke-user',
    class: '',
    action: 'removeEngineer',
    permissions: updateRemoveUsers,
    condition(project: Object, action: Object, callback: Function): React.Node {
      return (
        project.engineers &&
        project.engineers.length > 0 && <ActionButton action={action} onActionDrawer={callback} />
      );
    },
  },
  {
    label: 'general:actions.extend_project',
    icon: '#icon-extend-project',
    class: '',
    action: 'extend',
    permissions: updateExtendProject,
  },
  {
    label: 'general:actions.end_project',
    icon: '#icon-end-rental',
    class: '',
    action: 'end',
    permissions: updateEndProject,
    condition(project: Object, action: Object, callback: Function): React.Node {
      const vToday: Date = new Date();
      const vEndDt: Date = new Date(project.end_date);
      return vEndDt > vToday && <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
  {
    label: 'general:actions.assign_cost_center_plural',
    icon: '#icon-assign-cost-center',
    class: '',
    action: 'assignCostCenter',
    permissions: updateAssignCostCenters,
  },
  {
    label: 'general:actions.remove_cost_center_plural',
    icon: '#icon-remove-cost-center',
    class: '',
    action: 'removeCostCenter',
    permissions: updateRemoveCostCenters,
    condition(project: Object, action: Object, callback: Function): React.Node {
      return (
        project.cost_centres &&
        project.cost_centres.length > 0 && (
          <ActionButton action={action} onActionDrawer={callback} />
        )
      );
    },
  },
  {
    label: 'general:actions.archive_project',
    icon: '#icon-archive',
    class: '',
    action: 'archive',
    permissions: updateArchiveProject,
    condition(project: Object, action: Object, callback: Function): React.Node {
      return (
        project.status !== 'Archived' && <ActionButton action={action} onActionDrawer={callback} />
      );
    },
  },
  {
    label: 'general:actions.unarchive_project',
    icon: '#icon-unarchive',
    class: '',
    action: 'unarchive',
    permissions: updateUnarchiveProject,
    condition(project: Object, action: Object, callback: Function): React.Node {
      return (
        project.status === 'Archived' && <ActionButton action={action} onActionDrawer={callback} />
      );
    },
  },
];
